export enum Players {
	DAILYMOTION = 'dailymotion',
	DAILYMOTION_EMBED = 'dailymotion-embed',
	JWPLAYER = 'jwplayer',
	VIDEOJS = 'videojs'
}

(window as any).VideoPlayers = Players;
